import { mainApiAxios as axios } from '@/plugins/axios'
import { useStripHtml } from '@/helpers/common.js'

export default {
    

    generateBotResponse(userMessage) {
        return axios.get(`chatbot?userMessage=${userMessage}`)
    },
    generateSurveyFromAI(surveyTitle, number) {
        return axios.get(`chatbot/generate-survey?surveyTitle=${surveyTitle}&number=${number}`)
    }
}